import _slicedToArray from "/Users/tyler.jewell/Helix/helix.platform.core/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/Users/tyler.jewell/Helix/helix.platform.core/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import clsx from 'clsx';
import { serializeStyles } from '@emotion/serialize';
import { insertStyles, getRegisteredStyles } from '@emotion/utils';
import { useGuaranteedMemo } from './utils/use-guaranteed-memo/use-guaranteed-memo.js';
import { useEmotionCache } from './use-emotion-cache.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var refPropertyName = "ref";
function getRef(args) {
  var ref;
  if (args.length !== 1) {
    return {
      args: args,
      ref: ref
    };
  }
  var _args = _slicedToArray(args, 1),
    arg = _args[0];
  if (!(arg instanceof Object)) {
    return {
      args: args,
      ref: ref
    };
  }
  if (!(refPropertyName in arg)) {
    return {
      args: args,
      ref: ref
    };
  }
  ref = arg[refPropertyName];
  var argCopy = __spreadValues({}, arg);
  delete argCopy[refPropertyName];
  return {
    args: [argCopy],
    ref: ref
  };
}
var _ref = function () {
    function merge(registered, css, className) {
      var registeredStyles = [];
      var rawClassName = getRegisteredStyles(registered, registeredStyles, className);
      if (registeredStyles.length < 2) {
        return className;
      }
      return rawClassName + css(registeredStyles);
    }
    function _cssFactory(params) {
      var cache = params.cache;
      var css = function css() {
        for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
          styles[_key] = arguments[_key];
        }
        var _getRef = getRef(styles),
          ref = _getRef.ref,
          args = _getRef.args;
        var serialized = serializeStyles(args, cache.registered);
        insertStyles(cache, serialized, false);
        return "".concat(cache.key, "-").concat(serialized.name).concat(ref === void 0 ? "" : " ".concat(ref));
      };
      var cx = function cx() {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        return merge(cache.registered, css, clsx(args));
      };
      return {
        css: css,
        cx: cx
      };
    }
    return {
      cssFactory: _cssFactory
    };
  }(),
  cssFactory = _ref.cssFactory;
function useCss() {
  var cache = useEmotionCache();
  return useGuaranteedMemo(function () {
    return cssFactory({
      cache: cache
    });
  }, [cache]);
}
export { cssFactory, useCss };